import type { LiveTranscriptionSession } from '@/shared/api/transcriptor';

import { openDeepgramTranscription } from './deepgramTranscription';
import {
  openRealtimeTranscription,
  type RealtimeTranscriptionConnection,
  type RealtimeTranscriptionHandlers,
} from './realtimeTranscription';

type LiveTranscriptionConnector = (params: {
  session: LiveTranscriptionSession;
  handlers: RealtimeTranscriptionHandlers;
}) => RealtimeTranscriptionConnection;

// Scribe chooses the provider and names it in the session.
const LIVE_TRANSCRIPTION_CONNECTORS: Record<
  string,
  LiveTranscriptionConnector
> = {
  openai: openRealtimeTranscription,
  deepgram: openDeepgramTranscription,
};

const findConnector = (session: LiveTranscriptionSession) => {
  const provider = session.provider.toLowerCase();
  return Object.hasOwn(LIVE_TRANSCRIPTION_CONNECTORS, provider)
    ? LIVE_TRANSCRIPTION_CONNECTORS[provider]
    : null;
};

export const isSupportedLiveSession = (session: LiveTranscriptionSession) =>
  !!findConnector(session) &&
  !!session.clientSecret &&
  session.connectUrl.startsWith('wss://');

export const openLiveTranscription: LiveTranscriptionConnector = ({
  session,
  handlers,
}) => {
  const connect = findConnector(session);
  if (!connect) {
    throw new Error(
      `Unsupported live transcription provider: ${session.provider}`,
    );
  }
  return connect({ session, handlers });
};
